import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { IStore } from './store';
import { fetchPricingSubscription } from './actions';

export const usePricingSubscription = (accountNumber: string, accessToken: string) => {
  const dispatch = useDispatch();
  const pricingSubscription = useSelector((store: IStore) => store.subscriptions.pricingSubscription);
  const pricingSubscriptionResult = useSelector((store: IStore) => store.subscriptions.pricingSubscriptionResult);

  useEffect(() => {
    dispatch<any>(fetchPricingSubscription(accountNumber, accessToken));
  }, []);

  return { pricingSubscription, pricingSubscriptionResult };
};
